/**
 * Front-end model representing a group. See back-end complement for field descriptions.
 *
 * The following Field model attribute sets are located under the static `fields` attribute.
 * * id
 * * name
 * @module app/models/Group
 */
import Backbone from "backbone";
import _ from "underscore";
import UserCollection from "app/models/UserCollection";
import RequestUtils from "app/utils/RequestUtils";
import ErrorUtils from "app/utils/ErrorUtils";
import FieldUtils from "app/utils/FieldUtils";
import urlService from "app/UrlService";
var Group = Backbone.Model.extend(
  {
    defaults: {
      name: "",
    },

    initialize: function (attributes, options) {
      Backbone.Model.prototype.initialize.apply(this, arguments);

      this.options = _.defaults({}, options);
    },

    /**
     * Gets the users in this group.
     * @async
     * @param  {Function} callback Function expecting two arguments - the error, if any, and the `UserCollection` containing the users in this group, if no error occurred.
     * @param {Boolean} [refresh] True to force a refresh of data from the server, otherwise false.
     */
    getUsers: function (callback, refresh) {
      if (this._users && !refresh) {
        callback(null, this._users);
      } else {
        RequestUtils.get(
          this.url() + "/users",
          _.bind(function (data) {
            this._users = new UserCollection(data);
            callback(null, this._users);
          }, this)
        ).fail(function (jqXHR) {
          callback(ErrorUtils.normalizeError({}, jqXHR));
        });
      }
    },

    /**
     * Add a user to this group.
     * @param {string} u The ID of the user to add.
     * @async
     * @return {Promise} A promise object.
     */
    addUser: function (u) {
      this._users = null;

      return RequestUtils.post(this.url() + "/users", {
        user: u,
      });
    },

    /**
     * Remove a user form this group.
     * @param  {string} u The ID of the user to remove.
     * @return {Promise}   A promise object.
     */
    removeUser: function (u) {
      this._users = null;

      return RequestUtils.del(this.url() + "/users", {
        user: u,
      });
    },

    toJSON: function () {
      var json = Backbone.Model.prototype.toJSON.apply(this, arguments);

      delete json.users;

      return json;
    },

    /**
     * Validates the field values.
     * @param  {Function} cb Function expecting two arguments. The first is an error, if any, and the second is a mapping from field name to field error. If no validation errors occurred, this will be an empty object or undefined.
     * @async
     */
    validate: function (cb) {
      if (_.isFunction(cb)) {
        return RequestUtils.post(
          urlService.apiurl("/groups/" + this.id + "/validate"),
          this.attributes
        )
          .done(function (data) {
            cb(null, data);
          })
          .fail(function (xhr, data) {
            cb(data);
          });
      } else {
        //validate called by backbone - don't worry about this case for now
      }
    },
  },
  {
    fields: {
      id: FieldUtils.fieldPrototype("id", "Group", null),
      name: FieldUtils.fieldPrototype("name", "Name", "text"),
    },
  }
);

export default Group;



//////////////////
// WEBPACK FOOTER
// ./public/js/app/models/Group.js
// module id = 131
// module chunks = 1